type ClosePrimarySidebarHandler = () => void;

let closePrimarySidebarHandler: ClosePrimarySidebarHandler | null = null;

export function registerPrimarySidebarCloseHandler(
  handler: ClosePrimarySidebarHandler | null,
): () => void {
  closePrimarySidebarHandler = handler;
  return () => {
    if (closePrimarySidebarHandler === handler) {
      closePrimarySidebarHandler = null;
    }
  };
}

export function closePrimarySidebar(): void {
  closePrimarySidebarHandler?.();
}
